import { render, staticRenderFns } from "./PassportLayout.vue?vue&type=template&id=4facf526&scoped=true"
import script from "./PassportLayout.vue?vue&type=script&lang=js"
export * from "./PassportLayout.vue?vue&type=script&lang=js"
import style0 from "./PassportLayout.vue?vue&type=style&index=0&id=4facf526&prod&lang=scss"
import style1 from "./PassportLayout.vue?vue&type=style&index=1&id=4facf526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4facf526",
  null
  
)

export default component.exports